module.exports = {"new":["new"],"in_progress":["in_progress"],"canceled":["canceled"],"open":["new","acknowledged","assigned","in_progress"],"closed":["closed"]}


//////////////////
// WEBPACK FOOTER
// ./src/config/wo-status-options.json
// module id = 1041
// module chunks = 0